import requirejs from 'requirejs';

export interface StartupConfig {
  isInsideEditorX: boolean;
  shouldRender: boolean;
  measureFrameRate: boolean;
  shouldBiErrorsAndFedops: boolean;
  shouldLoadPolyfills: boolean;
  publicPath: string;
  loadMainCss: boolean;
  stylablePanelTheme?: string;
}

export const requirePromise = <T>(modulesToLoad: string[]) =>
  new Promise<T>((resolve, reject) =>
    requirejs(modulesToLoad, resolve, reject),
  );
